import React from "react";

interface AcademicYearSelectProps {
  options?: string[];
  selectedYear: string;
  onChange: (year: string) => void;
}

const AcademicYearSelect: React.FC<AcademicYearSelectProps> = ({
  options = [],
  selectedYear,
  onChange,
}) => {
  // Generate academic years if options are empty
  const getDefaultYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 3 }, (_, i) => {
      const startYear = currentYear - i;
      const endYear = startYear + 1;
      return `${startYear}/${endYear}`;
    });
  };

  const academicYears = options.length > 0 ? options : getDefaultYears();

  return (
    <div className="d-flex align-items-center p-0 flex-wrap">
      <div className="dropdown mb-0 p-0 me-0">
        <button
          className="btn btn-outline-light bg-white dropdown-toggle"
          data-bs-toggle="dropdown"
          data-bs-auto-close="inside"
        >
          <i className="ti ti-calendar-due me-0" />
          Year: {selectedYear}
        </button>
        <ul className="dropdown-menu p-0">
          {academicYears.map((year) => (
            <li className="p-0" key={year}>
              <button
                className={`dropdown-item rounded-1 ${
                  year === selectedYear ? "active" : ""
                }`}
                onClick={() => onChange(year)}
              >
                Year: {year}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AcademicYearSelect;
